import { updateLazy } from 'Functions/lazy';
import 'Layouts/default';
import '../ui/slider';

document.addEventListener('DOMContentLoaded', function() {
    updateLazy();
});